import {
	createRouter,
	createWebHistory
} from "vue-router";

import store from "../store/index"
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

const routes = [{
		path: "/login",
		name: "Login",
		meta: {
			title: '登录'
		},
		component: () => import(
			"@/views/Login.vue")
	},

	{
		path: '/404',
		meta: {
			title: '页面不存在'
		},
		component: () => import('@/views/404')
	}, {
		path: '/403',
		meta: {
			title: '权限不足'
		},
		component: () => import('@/views/403')
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes
});


router.beforeEach((to, from, next) => {
	document.title = `${to.meta.title}`;
	NProgress.start()
	// 登录页面路由限制
	let token = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")).token : false
	if (token) {
		if (to.path == '/404' || to.path == '/403') {
			next()
			NProgress.done()
		} else if (to.path == '/login') {
			next('/')
			NProgress.done()
		} else {
			// 判断路由是否有数据
			if (store.getters.routersLength == 0 || !store.state.updateSign) {
				store.dispatch('loadMenus').then((res) => {
					if (to.path == '/index') {
						next(res)
					} else {
						next({
							...to,
							replace: true
						})
					}
					store.commit("handleUpdateSign", true);
				}).catch(() => {
					next('/403')
					store.commit("handleUpdateSign", true);
				})
			} else if (to.matched.length === 0) {
				next(false)
				NProgress.done()
				// next('/404') // 判断此跳转路由的来源路由是否存在，存在的情况跳转到来源路由，否则跳转到404页面
			} else {
				next()
				NProgress.done()
			}
		}
	} else {
		if (to.path == '/login') { //token不存在，并且是login页面
			next();
			NProgress.done()
		} else { //token不存在，不是login页面
			next({
				path: '/login',
				replace: true
			})
		}
	}
});

export default router;